import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Col, Row, Pagination, Button, Form, Modal } from 'react-bootstrap';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { Title } from '../../components/Title';
import './style.css';

export function ResumoComissoesCredenciados() {
    const [isLoading, setIsLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);


    const [employees, setEmployees] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    const currentEmployees = employees.slice(indexOfFirstEmployee, indexOfLastEmployee);

    const filteredEmployees = employees.filter((employee: any) => {

        const cpfClean = employee.empresa.replace(/[\.-]/g, ''); // Remove '.' e '-'

        return (
            employee.empresa.toLowerCase().includes(searchQuery.toLowerCase()) ||
            cpfClean.includes(searchQuery) ||
            employee.id.toString().includes(searchQuery)
        );
    });
    useEffect(() => {
        const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
        const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
        const newCurrentFilteredEmployees = filteredEmployees.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

        setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    }, [currentPage, employeesPerPage, filteredEmployees]);

    // Function to load companies
    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            setCompanies(response.data.message ? [] : response.data);
            setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const loadEmployees = async (companyId: any) => {
        try {
            const response = await api.get('pagamentos/listarResumoPagamentos')
            console.log(response.data)
            setEmployees(response.data);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };
    // Load companies initially
    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        loadEmployees(selectedCompany);
    }, [selectedCompany]); // Carregar funcionários quando a empresa selecionada for alterada

    const handleSelectCompany = (id: any) => {
        setSelectedCompany(id);
    };

    const handleStatusChange = async (employeeId: any, currentStatus: any) => {
        const newStatus = currentStatus === true ? false : true;

        try {
            await api.post('status-funcionarios', { id_empresa: selectedCompany, id_funcionario: employeeId, status: newStatus });
            // Reload employees to reflect the change
            loadEmployees(selectedCompany);
        } catch (error) {
            console.error("Error updating employee status:", error);
        }
    };

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const getMesReferente = () => {
        const dataAtual = new Date();
        const mes = dataAtual.toLocaleDateString('pt-BR', { month: 'long' });
        const ano = dataAtual.toLocaleDateString('pt-BR', { year: '2-digit' });
        const mesReferente = `${mes.charAt(0).toUpperCase() + mes.slice(1)}/${ano}`;
        return mesReferente;
    }

    const getAnoReferente = () => {
        const dataAtual = new Date();
        const ano = dataAtual.toLocaleDateString('pt-BR', { year: '2-digit' });
        return ano;
    }
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleConfirm = () => {
        console.log('confirmou')
    }

    const [showVendas, setShowVendas] = useState(false);
    const handleCloseVendas = () => setShowVendas(false);
    const handleShowVendas = () => setShowVendas(true);

    const [fileComprovante, setFileComprovante] = useState(null);
    const handleFileComprovanteUpload = (event: any) => {
        setFileComprovante(event.target.files[0])
    }

    const [minimalPix, setMinimalPix] = useState("");
    useEffect(() => {
        if (!show) {
            setFileComprovante(null)
        }
    }, [show])
    const [mesReferente, setMesReferente] = useState(getMesReferente());
    const [mesReferenteRepresentantesComerciais, setMesReferenteRepresentantesComerciais] = useState(getMesReferente());

    const handleMesReferenteChange = (value: string) => {
        setMesReferente(value);
    };

    const handleMesReferenteRepresentantesComerciaisChange = (value: string) => {
        setMesReferenteRepresentantesComerciais(value);
    };

    useEffect(() => {
        console.log(mesReferenteRepresentantesComerciais)
    }, [mesReferenteRepresentantesComerciais])

    const [comissoesCredenciado, setComissoesCredenciado] = useState<any>({});
    const [comissoesRepresentantesComerciais, setComissoesRepresentantesComerciais] = useState<any>({});
    const [filteredComissoesCredenciado, setFilteredComissoesCredenciado] = useState<any>({});
    const [filteredComissoesRepresentantesComerciais, setFilteredComissoesRepresentantesComerciais] = useState<any>({});
    const loadComissoesCredenciado = async () => {
        try {
            const { data: user } = await api.get('dados-usuario');
            const userId = user.nome !== "Administrador" ? user.id : 1;
            const response = await api.post(`comissao/listar-comissoes-por-mes-credenciado`, { id_credenciado: userId });
            setComissoesCredenciado(response.data);
            const responseRepresentantesComerciais = await api.post(`comissao/listar-comissoes-por-mes-representante-de-venda`, { id_credenciado: userId });
            setComissoesRepresentantesComerciais(responseRepresentantesComerciais.data);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };
    useEffect(() => {
        loadComissoesCredenciado();
    }, [])

    useEffect(() => {
        const comissoesRepresentantesComerciaisFiltradas = (comissoesRepresentantesComerciais as Record<string, any>)[mesReferenteRepresentantesComerciais];
        if (comissoesRepresentantesComerciaisFiltradas) {
            setFilteredComissoesRepresentantesComerciais(comissoesRepresentantesComerciaisFiltradas);
        } else {
            setFilteredComissoesRepresentantesComerciais({});
        }
    }, [mesReferenteRepresentantesComerciais, comissoesRepresentantesComerciais])

    useEffect(() => {
        const comissoesCredenciadoFiltradas = (comissoesCredenciado as Record<string, any>)[mesReferente];
        if (comissoesCredenciadoFiltradas) {
            setFilteredComissoesCredenciado(comissoesCredenciadoFiltradas);
        } else {
            setFilteredComissoesCredenciado({});
        }
    }, [mesReferente, comissoesCredenciado])

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <CardContent>
                    <Row className='my-4'>
                        <Title text="Resumo das Minhas Comissões" />
                    </Row>
                    <Row>
                        <Col md={6} className='my-2 d-flex align-items-end' style={{ float: 'left' }}>
                            <Select id='mesReferenteSelect' value={mesReferente} onSelect={handleMesReferenteChange}>
                                <Options key={`Janeiro/${getAnoReferente()}`} value={`Janeiro/${getAnoReferente()}`} name={`Janeiro/${getAnoReferente()}`} selected={mesReferente === `Janeiro/${getAnoReferente()}`} />
                                <Options key={`Fevereiro/${getAnoReferente()}`} value={`Fevereiro/${getAnoReferente()}`} name={`Fevereiro/${getAnoReferente()}`} selected={mesReferente === `Fevereiro/${getAnoReferente()}`} />
                                <Options key={`Março/${getAnoReferente()}`} value={`Março/${getAnoReferente()}`} name={`Março/${getAnoReferente()}`} selected={mesReferente === `Março/${getAnoReferente()}`} />
                                <Options key={`Abril/${getAnoReferente()}`} value={`Abril/${getAnoReferente()}`} name={`Abril/${getAnoReferente()}`} selected={mesReferente === `Abril/${getAnoReferente()}`} />
                                <Options key={`Maio/${getAnoReferente()}`} value={`Maio/${getAnoReferente()}`} name={`Maio/${getAnoReferente()}`} selected={mesReferente === `Maio/${getAnoReferente()}`} />
                                <Options key={`Junho/${getAnoReferente()}`} value={`Junho/${getAnoReferente()}`} name={`Junho/${getAnoReferente()}`} selected={mesReferente === `Junho/${getAnoReferente()}`} />
                                <Options key={`Julho/${getAnoReferente()}`} value={`Julho/${getAnoReferente()}`} name={`Julho/${getAnoReferente()}`} selected={mesReferente === `Julho/${getAnoReferente()}`} />
                                <Options key={`Agosto/${getAnoReferente()}`} value={`Agosto/${getAnoReferente()}`} name={`Agosto/${getAnoReferente()}`} selected={mesReferente === `Agosto/${getAnoReferente()}`} />
                                <Options key={`Setembro/${getAnoReferente()}`} value={`Setembro/${getAnoReferente()}`} name={`Setembro/${getAnoReferente()}`} selected={mesReferente === `Setembro/${getAnoReferente()}`} />
                                <Options key={`Outubro/${getAnoReferente()}`} value={`Outubro/${getAnoReferente()}`} name={`Outubro/${getAnoReferente()}`} selected={mesReferente === `Outubro/${getAnoReferente()}`} />
                                <Options key={`Novembro/${getAnoReferente()}`} value={`Novembro/${getAnoReferente()}`} name={`Novembro/${getAnoReferente()}`} selected={mesReferente === `Novembro/${getAnoReferente()}`} />
                                <Options key={`Dezembro/${getAnoReferente()}`} value={`Dezembro/${getAnoReferente()}`} name={`Dezembro/${getAnoReferente()}`} selected={mesReferente === `Dezembro/${getAnoReferente()}`} />
                            </Select>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12} style={{ paddingTop: '30px' }}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Mês Referente</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Total de Vendas</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Total de Comissão</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Status</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '14px', fontWeight: 'normal' }}>Comprovante de Pagamento</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(filteredComissoesCredenciado).length > 0 ? (
                                                <tr style={{ textAlign: 'center' }}>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        {mesReferente}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        {filteredComissoesCredenciado.total_pedidos}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        R$ {Number(filteredComissoesCredenciado.total_comissao).toFixed(2)}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        {filteredComissoesCredenciado.comprovante_pagamento_credenciado.every((comprovante: any) => comprovante === null) ? (
                                                            <p style={{ color: 'red' }}>Pendente</p>
                                                        ) : (
                                                            <p style={{ color: 'green' }}>Pago</p>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        {filteredComissoesCredenciado.comprovante_pagamento_credenciado.every((comprovante: any) => comprovante === null) ? (
                                                            'Sem Comprovante'
                                                        ) : (
                                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                                {filteredComissoesCredenciado.comprovante_pagamento_credenciado.filter((comprovante: any) => comprovante !== null).map((comprovante: any, index: any) => (
                                                                    <a key={index} href={`data:application/pdf;base64,${encodeURIComponent(comprovante)}`} download={`comprovante_pagamento_${index + 1}.pdf`}>
                                                                        Baixar Comprovante {index + 1}
                                                                    </a>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan={5} style={{ padding: '15px', textAlign: 'center', fontSize: '12px' }}>
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
                <CardContent>
                    <Row className='my-4'>
                        <Title text="Resumo de Comissões - Representantes Comerciais" />
                    </Row>
                    <Row>
                        <Col md={6} className='my-2 d-flex align-items-end' style={{ float: 'left' }}>
                            <Select id='mesReferenteSelect' value={mesReferenteRepresentantesComerciais} onSelect={handleMesReferenteRepresentantesComerciaisChange}>
                                <Options key={`Janeiro/${getAnoReferente()}`} value={`Janeiro/${getAnoReferente()}`} name={`Janeiro/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Janeiro/${getAnoReferente()}`} />
                                <Options key={`Fevereiro/${getAnoReferente()}`} value={`Fevereiro/${getAnoReferente()}`} name={`Fevereiro/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Fevereiro/${getAnoReferente()}`} />
                                <Options key={`Março/${getAnoReferente()}`} value={`Março/${getAnoReferente()}`} name={`Março/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Março/${getAnoReferente()}`} />
                                <Options key={`Abril/${getAnoReferente()}`} value={`Abril/${getAnoReferente()}`} name={`Abril/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Abril/${getAnoReferente()}`} />
                                <Options key={`Maio/${getAnoReferente()}`} value={`Maio/${getAnoReferente()}`} name={`Maio/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Maio/${getAnoReferente()}`} />
                                <Options key={`Junho/${getAnoReferente()}`} value={`Junho/${getAnoReferente()}`} name={`Junho/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Junho/${getAnoReferente()}`} />
                                <Options key={`Julho/${getAnoReferente()}`} value={`Julho/${getAnoReferente()}`} name={`Julho/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Julho/${getAnoReferente()}`} />
                                <Options key={`Agosto/${getAnoReferente()}`} value={`Agosto/${getAnoReferente()}`} name={`Agosto/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Agosto/${getAnoReferente()}`} />
                                <Options key={`Setembro/${getAnoReferente()}`} value={`Setembro/${getAnoReferente()}`} name={`Setembro/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Setembro/${getAnoReferente()}`} />
                                <Options key={`Outubro/${getAnoReferente()}`} value={`Outubro/${getAnoReferente()}`} name={`Outubro/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Outubro/${getAnoReferente()}`} />
                                <Options key={`Novembro/${getAnoReferente()}`} value={`Novembro/${getAnoReferente()}`} name={`Novembro/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Novembro/${getAnoReferente()}`} />
                                <Options key={`Dezembro/${getAnoReferente()}`} value={`Dezembro/${getAnoReferente()}`} name={`Dezembro/${getAnoReferente()}`} selected={mesReferenteRepresentantesComerciais === `Dezembro/${getAnoReferente()}`} />
                            </Select>
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(employees.length / employeesPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Mês Referente</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Total de Vendas</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Total de Comissão</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Status</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '14px', fontWeight: 'normal' }}>Comprovante de Pagamento</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(filteredComissoesRepresentantesComerciais).length > 0 ? (
                                                <tr style={{ textAlign: 'center' }}>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        {mesReferenteRepresentantesComerciais}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        {filteredComissoesRepresentantesComerciais.total_pedidos}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        R$ {Number(filteredComissoesRepresentantesComerciais.total_comissao).toFixed(2)}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        {filteredComissoesRepresentantesComerciais.comprovante_pagamento.every((comprovante: any) => comprovante === null) ? (
                                                            <p style={{ color: 'red' }}>Pendente</p>
                                                        ) : filteredComissoesRepresentantesComerciais.comprovante_pagamento.some((comprovante: any) => comprovante === null) ? (
                                                            <p style={{ color: 'orange' }}>Pago Parcialmente</p>
                                                        ) : (
                                                            <p style={{ color: 'green' }}>Pago</p>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                        {filteredComissoesRepresentantesComerciais.comprovante_pagamento.every((comprovante: any) => comprovante === null) ? (
                                                            'Sem Comprovante'
                                                        ) : (
                                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                                {filteredComissoesRepresentantesComerciais.comprovante_pagamento.filter((comprovante: any) => comprovante !== null).map((comprovante: any, index: any) => (
                                                                    <a key={index} href={`data:application/pdf;base64,${encodeURIComponent(comprovante)}`} download={`comprovante_pagamento_${index + 1}.pdf`}>
                                                                        Baixar Comprovante {index + 1}
                                                                    </a>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan={5} style={{ padding: '15px', textAlign: 'center', fontSize: '12px' }}>
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
            </Main>
        </div >
    );
}